<template>
  <table class="table table-striped table-condensed">
    <thead>
    <tr>
      <th class="col-xs-6">
        <a href="#" @click.prevent="sort('name')">
          Channel <i class="fa fa-sort"></i>
        </a>
      </th>

      <th class="col-xs-4">
        <a href="#" @click.prevent="sort(indexColumn)">
          Index <i class="fa fa-sort"></i>
        </a>
      </th>

      <th class="col-xs-4">
        <a href="#" @click.prevent="sort('value')">
          Revenue <i class="fa fa-sort"></i>
        </a>
      </th>

      <th class="col-xs-4">
        <a href="#" @click.prevent="sort(targetColumn)">
          Target <i class="fa fa-sort"></i>
        </a>
      </th>

      <th class="col-xs-6">
        <a href="#" @click.prevent="sort(differenceColumn)">
          Difference <i class="fa fa-sort"></i>
        </a>
      </th>
    </tr>
    </thead>

    <tbody>
    <template v-for="row in sortedResult">
      <tr>
        <td>
        <span :style="{'background-color': row.color}">
          &nbsp;&nbsp;&nbsp;&nbsp;
        </span>

          &nbsp;

          <router-link
              v-if="row.channel_type === 'publication'"
              :to="'/portals/'+portal.id+'/publication-based-channels/'+row.channel_id+'/dashboard/'+year"
          >
            {{ row.name }}
          </router-link>

          <router-link
              v-if="row.channel_type === 'time'"
              :to="'/portals/'+portal.id+'/time-based-channels/'+row.channel_id+'/dashboard/'+year"
          >
            {{ row.name }}
          </router-link>
        </td>

        <td>
          <IndexNumber :value="row[indexColumn]"/>
        </td>

        <td>
          {{ row.value | price }}
        </td>

        <td>
          {{ row[targetColumn] | price }}
        </td>

        <td>
          <DifferenceNumber :value="row[differenceColumn]"/>
        </td>
      </tr>

      <tr v-for="subchannel in row.subchannels">
        <td>
          <span>
            &nbsp;&nbsp;&nbsp;&nbsp;
          </span>

          &nbsp;

          <span class="text-muted">
            -&nbsp;<router-link :to="'/portals/'+portal.id+'/time-based-subchannels/'+subchannel.id+'/dashboard/'+year">{{
              subchannel.name
            }}</router-link>
          </span>
        </td>
        <td>
          <IndexNumber :value="subchannel[indexColumn]"/>
        </td>
        <td>
          {{ subchannel.value | price }}
        </td>
        <td>
          {{ subchannel[targetColumn] | price }}
        </td>

        <td>
          <DifferenceNumber :value="subchannel[differenceColumn]"/>
        </td>
      </tr>
    </template>
    </tbody>

    <tfoot>
    <tr>
      <td>
        Total
      </td>

      <td>
        <IndexNumber :value="totalIndex"/>
      </td>

      <td>
        {{ totalRevenue | price }}
      </td>

      <td>
        {{ totalTarget | price }}
      </td>

      <td>
        <DifferenceNumber :value="totalDifference"/>
      </td>
    </tr>
    </tfoot>
  </table>
</template>

<script>
import DifferenceNumber from '@/components/Numbers/DifferenceNumber'
import IndexNumber from '@/components/Numbers/IndexNumber'
import Permissions from '@/mixins/Permissions'

export default {
  components: {DifferenceNumber, IndexNumber},

  mixins: [Permissions],

  props: ['portal', 'year', 'rows', 'targetMetric', 'result'],

  data() {
    return {
      sortBy: 'channel_name',
      sortDirection: -1
    }
  },

  computed: {
    targetColumn() {
      if (this.targetMetric === 'ad_target') {
        return 'target'
      }

      return 'management_target'
    },

    indexColumn() {
      if (this.targetMetric === 'ad_target') {
        return 'index'
      }

      return 'management_index'
    },

    differenceColumn() {
      if (this.targetMetric === 'ad_target') {
        return 'difference'
      }

      return 'management_difference'
    },

    sortedResult() {
      return this.result.sort((a, b) => {
        return a[this.sortBy] > b[this.sortBy] ? -this.sortDirection : this.sortDirection
      })
    },

    totalIndex() {
      if (!this.totalTarget) {
        return null
      }

      return this.totalRevenue / this.totalTarget * 100
    },

    totalRevenue() {
      return this.result.reduce((total, row) => {
        return total + row.value
      }, 0)
    },

    totalTarget() {
      return this.result.reduce((total, row) => {
        return total + row[this.targetColumn]
      }, 0)
    },

    totalDifference() {
      return this.result.reduce((total, row) => {
        return total + row[this.differenceColumn]
      }, 0)
    }
  },

  methods: {
    sort(key) {
      if (this.sortBy === key) {
        return this.sortDirection = -this.sortDirection
      }

      this.sortDirection = key === 'channel_name' ? -1 : 1

      this.sortBy = key
    }
  }
}
</script>
